import api from './interceptor';

const baseUrl = (appointmentId) => `api/v2/appointments/${appointmentId}/prescription-dme`;

export default {
  getCase: (appointmentId) => api.get(`${baseUrl(appointmentId)}/case`),
  patchCase: (appointmentId, payload) => api.patch(`${baseUrl(appointmentId)}/case`, payload),
  listMedicationClasses: (appointmentId) => api.get(`${baseUrl(appointmentId)}/templates/medication-classes`),
  listDmeProducts: (appointmentId) => api.get(`${baseUrl(appointmentId)}/templates/dme-products`),
  upsertMedicationSelection: (appointmentId, classCode, payload) => api.put(`${baseUrl(appointmentId)}/medication-selections/${classCode}`, payload || {}),
  removeMedicationSelection: (appointmentId, classCode) => api.delete(`${baseUrl(appointmentId)}/medication-selections/${classCode}`),
  upsertDmeSelection: (appointmentId, dmeCode, payload) => api.put(`${baseUrl(appointmentId)}/dme-selections/${dmeCode}`, payload || {}),
  removeDmeSelection: (appointmentId, dmeCode) => api.delete(`${baseUrl(appointmentId)}/dme-selections/${dmeCode}`),
  saveComplianceReview: (appointmentId, payload) => api.post(`${baseUrl(appointmentId)}/compliance-review`, payload || {}),
  getAuditLog: (appointmentId, params) => api.get(`${baseUrl(appointmentId)}/audit-log`, { params: params || {} }),
  previewPdf: (appointmentId) => api.get(`${baseUrl(appointmentId)}/case/preview-pdf`, { responseType: 'blob' }),
  signPacket: (appointmentId, payload) => api.post(`${baseUrl(appointmentId)}/case/sign`, payload || {}),
};
